<script setup lang="ts">/**
 * creating an adaptive sidebar
 */
import {ref} from "vue";

import {Briefcase, Contact, HeartHandshake, Home, Info, Menu, X} from "lucide-vue-next";


import '@/assets/styles/sidebar.css';

/**
 * ref-variable
 *
 * ÜBERSCHRIFT BLAU
 */
const isOpen = ref(false);

/**
 * Toggler for switching close and open
 */
const toggleSidebar = () => {
  isOpen.value = !isOpen.value;
}
</script>

<template>
  <div>
    <button v-if="!isOpen" class="menu" @click="toggleSidebar">
      <Menu/>
    </button>

    <div v-if="isOpen" class="overlay" @click="toggleSidebar"/>

  </div>
  <div class="sidebar" :class="{open: isOpen}">
    <div class="header">
      <button class="close-btn" @click="toggleSidebar">
        <X/>
      </button>
      <h1>Gallus Pflegedienst e.K.</h1>
    </div>
    <nav class="points">
      <router-link to="/" @click="toggleSidebar" class="points-link">
        <Home/>
        Home
      </router-link>
      <router-link to="/about" @click="toggleSidebar" class="points-link">
        <Info/>
        Über Uns
      </router-link>
      <router-link to="/services" @click="toggleSidebar" class="points-link">
        <HeartHandshake/>
        Dienstleistungen
      </router-link>
      <router-link to="/career" @click="toggleSidebar" class="points-link">
        <Briefcase/>
        Karriere
      </router-link>
      <router-link to="/contact" @click="toggleSidebar" class="points-link">
        <Contact/>
        Kontakt
      </router-link>
    </nav>
  </div>

</template>

<style scoped>

</style>